import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider';

const slider = {
	init(switcher) {
		this.sliders = document.querySelectorAll('.slider');

		// SI FONCTION ACTIVEE && SLIDER PRESENT 
		if (switcher && document.querySelector('.slider')) {
			this.sliders.forEach((slider) => {
				let sliderGenerate;

				// CREATION DES SLIDERS
				// DESKTOP
				if (window.matchMedia('(min-width: 1024px)').matches) {
					sliderGenerate = tns({
						container: slider.querySelector('.slider__wrapper'),
						items: 1,
						loop: false,
						speed: 400,
						gutter: 30,
						touch: true,
						controls: true,
						mouseDrag: true,
						controlsText: [ '', '' ],
						nav: true,
						navPosition: 'bottom',
						center: true,
						autoWidth: true
					});
				} else {
					// MOBILE TABLETTE ( probleme avec autowith, spération des deux codes et pas d'utilisation du responsive de Tiny-slider)
					sliderGenerate = tns({
						container: slider.querySelector('.slider__wrapper'),
						items: 1,
						loop: false,
						speed: 400,
						gutter: 0,
						touch: true,
						controls: true,
						mouseDrag: true,
						controlsText: [ '', '' ],
						nav: true,
						navPosition: 'bottom',
					});
				}
			});
		}
	}
};

export default slider;
